import React from 'react';
import styled from 'styled-components';
import { gray50 } from '../../theme/colors';
const Wrapper = styled.tr`
  color: inherit;
  display: table-row;
  outline: 0;
  vertical-align: middle;
  ${({
  highlighted
}) => highlighted && `background: ${gray50};`}
`;
export const TableRow = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, props, children);
export default TableRow;
//# sourceMappingURL=index.js.map